import { Injectable } from '@angular/core';
import { FateNode, FateParserService, FateType } from 'fate-editor';

/**Classe dei servizi customizzati per l'editor */
@Injectable()
export class CustomParserService extends FateParserService {

  /**Costruttore per la classe CustomParserService */
  constructor() {
    super();
  }

  /**
   * Metodo che effettua il parsing da HTML a FateNode
   * @param element {HTMLElement} nodo HTML da convertire in entrata
   * @returns elenco dei FateNode
   */
  public parseType(element: HTMLElement): Array<FateNode> {
    if (element.nodeName === 'SPAN' && element.classList.contains('note')) {
      return [new FateNode(('note' as FateType), {
        style: element.getAttribute('style'),
        rel: element.hasAttribute('rel') ? element.getAttribute('rel') : '?',
        val: element.textContent,
        title: ''
      })];
    } else if (element.nodeName === 'SPAN' && element.classList.contains('bold')) {
      return [new FateNode(FateType.BOLD)];
    } else if (element.nodeName === 'SPAN' && element.classList.contains('italic')) {
      return [new FateNode(FateType.ITALIC)];
    } else if (element.nodeName === 'SPAN' && element.classList.contains('underline')) {
      return [new FateNode(FateType.UNDERLINE)];
    } else if (element.nodeName === 'SPAN' && element.classList.contains('glossary')) {
      return [new FateNode(('glos-linguistica' as FateType), {
        style: element.getAttribute('style'),
        rel: element.hasAttribute('rel') ? element.getAttribute('rel') : '?',
        val: element.innerHTML,
      })];
    } else if (element.nodeName === 'SPAN' && element.classList.contains('smallcaps')) {
      return [new FateNode(('smallcaps' as FateType), {
        style: element.getAttribute('style'),
        val: element.innerHTML,
      })];
    } else if (element.nodeName === 'SPAN' && element.classList.contains('original')) {
      return [new FateNode(('original' as FateType), {
        val: element.innerText
      })];
    } else if (element.nodeName === 'IMG') {
      return [new FateNode(('image' as FateType), {
        src: element.getAttribute('src')
      })]
    } else if (element.nodeName === 'FONT') {
      return [new FateNode(('font' as FateType), {
        val: element.innerHTML,
        face: element.hasAttribute('face') ? element.getAttribute('face') : '',
        size: element.hasAttribute('size') ? element.getAttribute('size') : '',
        color: element.hasAttribute('color') ? element.getAttribute('color') : ''
      })];
    } else {
      return super.parseType(element);
    }
  }

  /**
   * Metodo che converte i FateNode in codice HTML
   * @param node {FateNode} singolo nodo Fate
   */
  protected serializeType(node: FateNode) {
    if ((node.type as string) === 'note') {
      return '<span class="note" style="' + node.value.style + '" rel="' + node.value.rel + '">' + node.value.val + '</span>';
    } else if ((node.type as string) === 'glos-linguistica') {
      return '<span class="glossary" style="' + node.value.style + '" rel="' + node.value.rel + '">' + node.value.val + '</span>'
    } else if ((node.type as string) === 'smallcaps') {
      return '<span class="smallcaps" style="' + node.value.style + '">' + node.value.val + '</span>'
    } else if ((node.type as string) === 'original') {
      return '<span class="original">' + node.value.val + '</span>';
    } else if ((node.type as string) === 'image') {
      return '<img src="' + node.value.src + '">';
    } else if ((node.type as string) === 'font') {
      return '<font face="' + node.value.face + '" size="' + node.value.size + '" color="' + node.value.color + '">' + node.value.val + '</font>';
    } else {
      return super.serializeType(node);
    }
  }
}
